export const textValidator = (
  value: string,
  cb: (m?: string) => void,
  message: string,
  minLength = 0
) => {
  const text = value?.replace(/<[^>]*>/g, '').trim() as string;

  if (!value || text === '' || text.length < minLength) {
    cb(message);
  }

  cb();
};

export const PERSON_NAME_REGEX = /^[\p{L}\s'\-–—]+$/u;

export const getFullNameValidationError = (
  value: string | undefined,
  fieldLabel = 'Nome Completo'
) => {
  const trimmedValue = value?.trim();

  if (!trimmedValue) {
    return undefined;
  }

  if (trimmedValue.split(/\s+/).length < 2) {
    return `${fieldLabel} deve ter ao menos nome e sobrenome`;
  }

  if (!PERSON_NAME_REGEX.test(trimmedValue)) {
    return `${fieldLabel} deve conter apenas letras, espaços, hífens ou apóstrofos`;
  }

  return undefined;
};

export const isValidFullName = (value: string) =>
  Boolean(value?.trim()) && !getFullNameValidationError(value);

const cpfCheckDigit = (digits: string) => {
  const weightStart = digits.length + 1;
  const sum = [...digits].reduce(
    (acc, digit, i) => acc + Number(digit) * (weightStart - i),
    0
  );
  const rest = (sum * 10) % 11;

  return rest === 10 ? 0 : rest;
};

// Sequências com dígito verificador correto que o atlas recusa (`CPF::BLACKLIST` da gem
// cpf_cnpj). Aceitá-las aqui faria a API gravar o aluno sem CPF, sem erro na importação.
const BLOCKED_CPFS = new Set(['01234567890', '12345678909']);

/** Valida os dígitos verificadores de um CPF, com ou sem máscara. */
export const isValidCPF = (value: string | undefined) => {
  const digits = value?.replace(/\D/g, '') ?? '';

  if (
    digits.length !== 11 ||
    /^(\d)\1{10}$/.test(digits) ||
    BLOCKED_CPFS.has(digits)
  ) {
    return false;
  }

  return (
    cpfCheckDigit(digits.slice(0, 9)) === Number(digits[9]) &&
    cpfCheckDigit(digits.slice(0, 10)) === Number(digits[10])
  );
};

export const fullNameValidatorRule =
  (fieldLabel = 'Nome Completo') =>
  () => ({
    validator(_: unknown, value: string) {
      const errorMessage = getFullNameValidationError(value, fieldLabel);

      if (!errorMessage) {
        return Promise.resolve();
      }

      return Promise.reject(new Error(errorMessage));
    }
  });
